module.exports = __webpack_public_path__ + "img/delete_black_24dp.18b63f91.png";